import isomorphic from './isomorphic';

const fakeClick = (target: HTMLElement): void => {
  const fakeEvent = isomorphic.window.document.createEvent('MouseEvents');
  fakeEvent.initMouseEvent(
    'click',
    true,
    false,
    isomorphic.window,
    0,
    0,
    0,
    0,
    0,
    false,
    false,
    false,
    false,
    0,
    null,
  );
  target.dispatchEvent(fakeEvent);
};

export default fakeClick;
